import React, { useState } from 'react'
import { Row, Card, Col, Button, Modal } from "react-bootstrap";
import { maskDocument } from 'helpers/document';
import { formatMoney } from 'helpers/Currency';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useCompany } from 'models';
import moment from 'moment';

import * as elite from '../../images/logo-elite.png';
import * as scancash from '../../images/scancash.png';
import * as elitePass from '../../images/logo/logo_elite_pass.png'
import * as scanSelect from '../../images/logo/logo_scansource_select_colorido.png'

export default function CompanyData() {
  moment.locale('pt-br')
  const { company: currentCompany } = useCompany()
  const storageCompany = JSON.parse(localStorage.getItem("Elite:company")) ?? currentCompany
  const { id: fiscalYear } = JSON.parse(localStorage.getItem("Elite:fiscalYear")) ?? {}
  const [showModalContract, setShowModalContract] = useState(false)

  function showCategory(category) {
    switch (category) {
      case 1: return <img src={elite} className="" alt="elite" height="25" />
      case 2: return "Elite Gerencial"
      case 3: return <img src={scancash} className="" alt="scancash" height="25" />
      case 4: return <img src={elitePass} className="" alt="scancash" height="55" />
      case 5: return <img src={scanSelect} className="" alt="scancash" height="55" />
      default: return "Sem categoria"
    }
  }

  function showMasterAgentCategory(ma_category) {
    if (ma_category == 1) {
      return "Ouro"
    } else {
      return "Prata"
    }
  }

  function getColorTrophy(position) {
    switch (position) {
      case 1: return 'gold'
      case 2: return 'silver'
      case 3: return '#cd7f32'
      default: return 'gray'
    }
  }

  function adhesionInfo({ adhesion }) {
    if (!adhesion.length)
      return null

    if (!adhesion)
      return adhesionLabel()

    const d = adhesion.filter((item) => item.fiscal_year_id == fiscalYear)[0]
    return !!d ? moment(new Date(d?.date_accept)).format('DD/MM/YYYY') : "--"
  }

  const handleClose = () => setShowModalContract(false)

  function modalContract() {
    return (
      <Modal size='lg' show={showModalContract} onHide={handleClose}>
        <Modal.Header closeButton>Contrato de Adesão dos Programas Scancash/Elite</Modal.Header>
        <Modal.Body>
          o texto do contrato vai ficar aqui
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  function getInvoicingValue() {
    const result = storageCompany.invoicing?.find(item => item.fiscal_year_id == fiscalYear)
    if (result)
      return formatMoney(result?.value)
    else
      return formatMoney(0)
  }

  const adhesionLabel = () => {
    return (
      <p>Ainda não realizou a adesão <FontAwesomeIcon icon={faExclamationTriangle} color="orange" /></p>
    )
  }

  return (
    <Card className="mt-2 shadow">
      <Card.Body>
        <Row>
          <Col md="12">
            <h6 className="title-dashboard">Dados cadastrais</h6>
            <hr className="line"></hr>
          </Col>
          <Col md="12">
            <Row>
              <Col md="4">
                <h4>Classificação:</h4>
                {[1, 3, 4, 5].includes(storageCompany.is_premium) ? (
                  <p className='h5 text-muted'>
                    {currentCompany.ranking_accelerator.position}ª {' '} <FontAwesomeIcon icon={faTrophy} color={getColorTrophy(currentCompany.ranking_accelerator.position)} />
                  </p>
                ) : (
                  <p>Sem Classificação</p>
                )}
              </Col>

              {[1, 3, 4, 5].includes(storageCompany.is_premium) && (
                <Col md="4">
                  <h4>Categoria:</h4>
                  {showCategory(currentCompany.getYearData(fiscalYear).is_premium)}
                </Col>
              )}

              {storageCompany.is_masteragent == 1 && (
                <Col md="4">
                  <h4>Categoria Master Agent:</h4>
                  <p className='text-muted'>{showMasterAgentCategory(storageCompany.ma_category)}</p>
                </Col>
              )}

              <Col md="4">
                <h4>Grupo:</h4>
                <p className='text-muted'>{currentCompany.group_name}</p>
              </Col>

              <Col md="4">
                <h4>Razão Social:</h4>
                <p className='text-muted'>{currentCompany.name}</p>
              </Col>

              <Col md="4">
                <h4>Nome Fantasia:</h4>
                <p className='text-muted'>{currentCompany.company_name}</p>
              </Col>

              <Col md="4">
                <h4>CNPJ:</h4>
                <p className='text-muted'>{maskDocument(currentCompany.document)}</p>
              </Col>

              <Col md="4">
                <h4>Faturamento do Grupo:</h4>
                <p className='text-muted'>{getInvoicingValue()}</p>
              </Col>

              {[1, 3, 4].includes(storageCompany.is_premium) && !!storageCompany.adhesion?.length && (
                <Col md="4">
                  <h4>Data de Adesão:</h4>
                  <p className='text-muted'>{adhesionInfo(currentCompany)}</p>
                </Col>
              )}

              {/* {currentCompany.is_masteragent && !currentCompany.is_premium ? (<></>) : (
                <Col md="4">
                  <h4>Data de Adesão:</h4>
                  <p>{
                    currentCompany.adhesion && currentCompany.adhesion[0].date_accept ? 
                    moment(new Date(currentCompany.adhesion[0].date_accept)).format('DD/MM/YYYY') : 
                    adhesionLabel()
                  }</p>
                </Col>
              )} */}
            </Row>
          </Col>
        </Row>
        {modalContract()}
      </Card.Body>
    </Card>
  )
}